import React from "react";
// import { Provider } from 'react-redux'
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router";
import { BrowserRouter } from "react-router-dom"
import indexRoutes from "routes/index.jsx";

// import store from './store'

import "assets/scss/material-kit-react.css?v=1.1.0";

var hist = createBrowserHistory();

// console.log(store)
ReactDOM.render(
  // <Provider store={store}>
    <Router history={hist}>
      <BrowserRouter >
        <Switch>
          {indexRoutes.map((prop, key) => {
            return <Route path={prop.path} key={key} component={prop.component} />;
          })}
        </Switch>
      </BrowserRouter>
    </Router>,
  // </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js